import { render, staticRenderFns } from "./AdditionalVisitorSafeguardingSection.vue?vue&type=template&id=16c2488b&"
import script from "./AdditionalVisitorSafeguardingSection.vue?vue&type=script&lang=js&"
export * from "./AdditionalVisitorSafeguardingSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports